import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { tryCreateNote, tryFetchNotes } from "../../../../actions/notes";
import { DefaultLoader, DashboardHeaderTitle, getViolations } from "@rdcs/dap-front-library";

import NoteItem from "../../../../components/Coordinator/Notes/NoteItem";
import LookLink from "../../LookLink";

import RightSection from "./RightSection";

const Notes = ({ patientId, patientNotes, createLoading, createError, tryCreateNote, auth }) => {
    return (
        <section>
            <DashboardHeaderTitle
                title="Dernières notes"
                icon="questionnaire"
                className="mt-4 mb-2"
                renderRightSection={
                    <RightSection auth={auth} tryCreateNote={tryCreateNote} patientId={patientId} createLoading={createLoading} createError={createError} />
                }
            />
            <div>
                {patientNotes.length === 0 ? (
                    <p>Aucune note pour ce patient actuellement.</p>
                ) : (
                    <>
                        <div className="reportsList grid grid__padding-10">
                            {patientNotes.map((note) => (
                                <div className="col-md-33 col-sm-100" key={note.id}>
                                    <NoteItem auth={auth} key={note.id} patientId={patientId} note={note} />
                                </div>
                            ))}
                        </div>
                        <p className="mt-2">
                            <LookLink link={`/facilitateurs/patient/${patientId}/notes`}>Voir les notes précédentes</LookLink>
                        </p>
                    </>
                )}
            </div>
        </section>
    );
};

Notes.propTypes = {
    patientId: PropTypes.number.isRequired,
    patientNotes: PropTypes.arrayOf(PropTypes.object).isRequired,
    createLoading: PropTypes.bool.isRequired,
    createError: PropTypes.object.isRequired,
    tryFetchNotes: PropTypes.func.isRequired,
};

const mapStateToProps = ({ notes: { list, createLoading, createError }, auth }) => ({
    patientNotes: list
        .filter((note) => note.active === true)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .slice(0, 3),
    createLoading,
    createError: getViolations(createError),
    auth,
});

const mapDispatchToProps = {
    tryFetchNotes,
    tryCreateNote,
};

export default React.memo(connect(mapStateToProps, mapDispatchToProps)(Notes));
